

import React from 'react'
import bg from "../../assets/backgrounDegradé.jpg"
import { useTranslation } from 'react-i18next';

function Solutions() {
  const { t } = useTranslation();
  const solutionsList = [
    { title: "solution_interface", text: "solution_interface_text", image: "https://www.boosterbc.com/images/services/it-service1.png", list: [] },
    { title: "solution_api", text: "solution_api_text", image: "https://www.boosterbc.com/images/app/about-app.png", list: [] }
  ]


  return (
    <div className="position-relative" >
      {/* Hero Section with Background Image */}
      <img
        src={bg}
        alt="main bg"
        width="100%"
        style={{
          height: "70vh",
          objectFit: "cover"
        }}
      />

      {/* Hero Text Overlay */}
      <div className="position-absolute w-100 h-100 top-0 start-0 text-white">
        <div className="container-xl">
          <div className="mt-5 pt-5">
            <h1 className="mt-5 text-primary-blue text-center" style={{ fontSize: 'clamp(2rem, 8vw, 4.5rem)' }} dangerouslySetInnerHTML={{
              __html: t("solutions_title"),
            }}></h1>
            <p
              className="text-center fw-medium fs-5 text-primary-blue">{t("solutions_subtitle")}</p>

          </div>

        </div>

      </div>
      <div className='container'>
        <div className='fs-1 text-center pt-4 mt-4'>{t("our_solutions")}</div>
        <p className='text-center mb-4 pb-4'>{t("solutions_caption")}</p>
         {solutionsList.map((element, i) => (
          <div className={`row align-items-center py-4 ${i === 1 ? 'flex-row-reverse' : ''}`}>
            <div className='col-md-6 p-4'>
              <h1 className="text-blue pt-2 fw-bold">{t(element.title)}</h1>
              <div className="pt-3 fw-medium fs-5">
                {t(element?.text)}
              </div>
            </div>
            <div className='col-md-6'>
              <img src={element?.image} alt={element.title} className="img-fluid" style={{
                maxWidth: "100%",
                height: "auto",
              }} />
            </div>
          </div>
        ))}
      </div>
    </div>

  )
}

export default Solutions